import { useEffect } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { useAuth } from '@shared/common/providers/AuthProvider';
import { useSocket } from '@shared/common/providers/SocketProvider';

import { setEntryInPool, setEntryInPools } from './changeEntries';

export const useWatchBuyEntries = ({ type }: { type: 'list' | 'item' }) => {
  const queryClient = useQueryClient();
  const { isAuth } = useAuth();
  const { socket } = useSocket();

  const updateActions = type === 'list' ? setEntryInPools : setEntryInPool;

  useEffect(() => {
    if (!socket || !isAuth) {
      return;
    }

    socket?.emit('call', 'join', { room: 'reward-pool' });
    socket.on('entry.bought', (data: { poolId: number; entriesLeft: number }) => {
      updateActions({ poolId: data.poolId, entrieLeft: data.entriesLeft, queryClient });
    });

    return () => {
      socket?.emit('call', 'left', { room: 'reward-pool' });
      socket.off('entry.bought');
    };
  }, [socket, isAuth]);
};
